import { initialFormState } from './constants';

export let regxObj = {}
for (let i in initialFormState) {
    regxObj[i] = /\w/;  // default pattern for all the fields, overwriting can be done in below
}

regxObj = {
    ...regxObj,
    route: /^[a-zA-Z ]*$/,
    numberOfSitesPlanned:  /^[1-9]\d*$/,
    numberOfSubPlanned: /^[1-9]\d*$/,
    email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    useremail:/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    forgot_email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    // phone: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
    // userphone:/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),._'?":{}|<>])(?=.{8,})/,
    // zip:/^[0-9]/
}
export const regX = {
    us: {
        zip: /\w/
    },
    in: {
        zip: /[1-6]/
    },
    gb: {
        zip: /\w/
    },
    default: {
        email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        isEmpty: '/^\w+$/',
        phone: /\w/,
        password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),_'.?":{}|<>])(?=.{8,})/,
        cpassword: /\w/,
        username: /\w/,
        currency: /\w/,
        fname: /\w/,
        lname: /\w/,
        mname: /\w/,
        lang: /\w/,
        roles: /\w/,
        accountName: /\w/,
    }
}
